import { withStylePrefix } from '../common/withStylePrefix';
import { ThumbnailComponent, thumbnailTemplate } from './Thumbnail';
import styles from './Thumbnail.styles.scss';
export const thumbnailDefinition = {
    baseName: 'thumbnail',
    template: thumbnailTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonThumbnail = ThumbnailComponent.compose(thumbnailDefinition);
